import { SVGProps, Ref, forwardRef } from 'react'
const SvgColorWhatsapp = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path fill="#fff" d="M5 5h14v14H5z" />
    <path
      fill="#25D366"
      fillRule="evenodd"
      d="M2.61 18.022 1 23.903l6.018-1.578a11.35 11.35 0 0 0 5.425 1.381h.005c6.257 0 11.35-5.091 11.352-11.349a11.278 11.278 0 0 0-3.322-8.029A11.28 11.28 0 0 0 12.448 1C6.19 1 1.098 6.09 1.095 12.348c0 2 .522 3.953 1.516 5.674Zm6.238-11.1c.21.01.441.019.661.508.15.335.404.958.605 1.455.15.366.27.664.301.726.074.147.123.319.025.515l-.042.084c-.073.15-.127.26-.252.406-.049.057-.1.118-.15.18a4.942 4.942 0 0 1-.29.335c-.148.146-.301.305-.13.599.172.294.761 1.256 1.635 2.035a7.594 7.594 0 0 0 2.167 1.37c.082.035.147.064.196.088.294.147.465.123.636-.074.172-.196.735-.857.93-1.151.197-.294.393-.245.662-.147.27.097 1.714.808 2.008.955.057.03.11.055.16.079.205.099.344.166.403.264.073.123.073.711-.172 1.397-.244.686-1.444 1.348-1.983 1.397-.052.005-.103.01-.156.017-.498.059-1.127.133-3.37-.752-2.76-1.089-4.58-3.786-4.956-4.343a3.27 3.27 0 0 0-.063-.092l-.003-.005c-.159-.211-1.197-1.599-1.197-3.034 0-1.353.665-2.063.971-2.39l.057-.06a1.08 1.08 0 0 1 .784-.368h.032c.185 0 .37 0 .531.006Z"
      clipRule="evenodd"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColorWhatsapp)
export default ForwardRef
